import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import SWOTWeb from './swotIndia';

function App() {
  return (
    <SWOTWeb></SWOTWeb>
  );
}

export default App;